module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-head"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', {
    staticClass: "toc_fm"
  }, [_c('p', {
    staticClass: "toc_fm"
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780107158_epub_cvi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "df42f5abd977e-d1e204"
    }
  }), _c('p', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "id": "df42f5abd977e-d1e204"
    }
  }), _c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780107158_epub_alb"
    }
  }, [_vm._v("A Selection of Titles From Sarah R. Shaber")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "df42f5abd977e-d1e239"
    }
  }), _c('p', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "id": "df42f5abd977e-d1e239"
    }
  }), _c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780107158_epub_tp"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "d6d393e5e4d7d-d1e32"
    }
  }), _c('p', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "id": "d6d393e5e4d7d-d1e32"
    }
  }), _c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780107158_epub_cop"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "df42f5abd977e-d1e332"
    }
  }), _c('p', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "id": "df42f5abd977e-d1e332"
    }
  }), _c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780107158_epub_ded"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "df42f5abd977e-d1e335"
    }
  }), _c('p', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "id": "df42f5abd977e-d1e335"
    }
  }), _c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780107158_epub_ack"
    }
  }, [_vm._v("Acknowledgements")])])]), _c('div', {
    staticClass: "toc_body"
  }, [_c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "df42f5abd977e-d1e340"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "df42f5abd977e-d1e340"
    }
  }), _c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780107158_epub_chap001"
    }
  }, [_vm._v("Chapter One")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "df42f5abd977e-d1e618"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "df42f5abd977e-d1e618"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780107158_epub_chap002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Two")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "df42f5abd977e-d1e986"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "df42f5abd977e-d1e986"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780107158_epub_chap003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "df42f5abd977e-d1e1219"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "df42f5abd977e-d1e1219"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780107158_epub_chap004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "df42f5abd977e-d1e1450"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "df42f5abd977e-d1e1450"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780107158_epub_chap005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "df42f5abd977e-d1e1743"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "df42f5abd977e-d1e1743"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780107158_epub_chap006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "df42f5abd977e-d1e2108"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "df42f5abd977e-d1e2108"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780107158_epub_chap007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "df42f5abd977e-d1e2613"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "df42f5abd977e-d1e2613"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780107158_epub_chap008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "df42f5abd977e-d1e2824"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "df42f5abd977e-d1e2824"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780107158_epub_chap009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nine")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "df42f5abd977e-d1e3251"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "df42f5abd977e-d1e3251"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780107158_epub_chap010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Ten")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "df42f5abd977e-d1e3407"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "df42f5abd977e-d1e3407"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780107158_epub_chap011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eleven")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "df42f5abd977e-d1e3784"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "df42f5abd977e-d1e3784"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780107158_epub_chap012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twelve")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "df42f5abd977e-d1e4059"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "df42f5abd977e-d1e4059"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780107158_epub_chap013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirteen")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "df42f5abd977e-d1e4314"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "df42f5abd977e-d1e4314"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780107158_epub_chap014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fourteen")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49cca6f5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781780107158_epub_itoc.vue
// module id = 60
// module chunks = 0